import { useRouter } from 'next/router';
import { FC, ReactElement, useEffect, useState } from 'react';
import LoadingContent from '~/components/LoadingContent';
import Render404 from '~/components/Render404';
import { ROUTES, ROUTES_REGEX } from '~/constants/ROUTES';
import { isPathEquivalent, isRegexPathEquivalent } from '~/helpers/path';
import useLogger from '~/hooks/useLogger';
import { InnerContainer, OuterContainer } from './styles';
const Page: FC = (): ReactElement<unknown> => {
  const logger = useLogger('404_PAGE');
  const [loading, setLoading] = useState(true);
  const [shouldNavigate, setShouldNavigate] = useState(false);
  const [logged404, setLogged404] = useState(false);
  const router = useRouter();
  logger.debug('NotFound404', {
    routerAsPath: router.asPath,
    routes: ROUTES_REGEX
  });
  useEffect((): void => {
    if (isPathEquivalent(ROUTES.INDEX, router.asPath)) {
      setShouldNavigate(true);
    } else {
      setShouldNavigate(Object.keys(ROUTES_REGEX).some(routeKey => isRegexPathEquivalent(ROUTES_REGEX[routeKey as keyof typeof ROUTES_REGEX], router.asPath)));
    }
    setLoading(false);
  }, [router]);
  useEffect((): void => {
    if (shouldNavigate) {
      // eslint-disable-next-line promise/prefer-await-to-then
      router.replace(router.asPath).catch(error => {
        logger.error('Error while replacing 404 route', error);
      });
    } else if (!loading && !logged404) {
      logger.error(`${router.asPath} requested: 404`);
      setLogged404(true);
    }
  }, [logger, router, shouldNavigate, loading, logged404]);
  return <OuterContainer data-sentry-element="OuterContainer" data-sentry-component="Page" data-sentry-source-file="index.tsx">
      <InnerContainer data-sentry-element="InnerContainer" data-sentry-source-file="index.tsx">
        {(loading || shouldNavigate) && <LoadingContent />}

        {!loading && !shouldNavigate && <Render404 />}
      </InnerContainer>
    </OuterContainer>;
};
export default Page;